import { customStyle, defaultStyle } from '../../../../../../constant/custom-style';
import { selectIsUpdateRatesState } from '../../../../../../features/actuarial/rates-slice';
import { useSelector } from 'react-redux';
import { RatesUpdateType } from '../../../../../../types/type';
import { GcliRateGroup, RatesInfo } from '../../../../../../features/actuarial/rates-state';

interface Props {
    tbody: RatesInfo[];
    tbodyInputs?: GcliRateGroup[];
    handleChangeAmount: (id: number, amount: string, groupTitle: string, type: RatesUpdateType) => void;
    handleBlurAmount?: (id: number, amount: string, groupTitle: string, type: RatesUpdateType) => void;
    dataRates: GcliRateGroup[];
    isRatesIsAgeType: boolean;
    isDisableInput: boolean;
}

export default function TbodyRatesAll({
    isDisableInput,
    isRatesIsAgeType,
    dataRates,
    tbody,
    tbodyInputs,
    handleChangeAmount,
    handleBlurAmount,
}: Props) {
    const isUpdateRates = useSelector(selectIsUpdateRatesState);

    return (
        <tbody>
            {!isRatesIsAgeType ? (
                tbody.map((termItem, index) => (
                    <tr key={index} className={`border-b border-gray-100 last:border-b-0 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-[#186cb2]/5`}>
                        <td className={`sticky left-0 z-10 border-r border-gray-200 px-3 py-1.5 text-center text-[11px] font-medium text-gray-700 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                            {termItem.name}
                        </td>

                        {dataRates?.map((group, index, array) => {
                            const cell = group.data.find((d) => {
                                if (termItem.type === "plan") {
                                    return d.type === "plan" && d.plan_id === termItem.plan_id;
                                }

                                return d.type === "rider" && d.rider_id === termItem.rider_id;
                            });

                            const id = termItem.type === "plan" ? termItem.plan_id : termItem.rider_id;

                            if (id == null) return null;

                            return (
                                <td key={group.title} className={`px-2 py-1.5 ${index !== array.length - 1 ? 'border-r border-gray-100' : ''}`}>
                                    <input
                                        type="text"
                                        disabled={!isUpdateRates || isDisableInput}
                                        value={cell?.amount ?? ''}
                                        onChange={(e) => handleChangeAmount(id, e.target.value, group.title, termItem.type)}
                                        onBlur={(e) => handleBlurAmount?.(id, e.currentTarget.value, group.title, termItem.type)}
                                        className={`w-full min-w-[80px] rounded border px-2 py-1 text-right text-[11px] outline-none transition-colors ${defaultStyle} ${isUpdateRates === false ? 'border-transparent bg-transparent' : cell?.amount ? customStyle : 'border-gray-300 bg-white focus:border-[#186cb2] focus:ring-1 focus:ring-[#186cb2]/20'}`}
                                    />
                                </td>
                            );
                        })}
                    </tr>
                ))
            ) : (
                dataRates.map((dataRateAge, groupIndex) => (
                    <tr key={dataRateAge.title} className={`border-b border-gray-100 last:border-b-0 ${groupIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-[#186cb2]/5`}>
                        <td className={`sticky left-0 z-10 border-r border-gray-200 px-3 py-1.5 text-center text-[11px] font-medium text-gray-700 ${groupIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                            {dataRateAge.title}
                        </td>

                        {dataRateAge.data.map((termItem, index, array) => {
                            const id = termItem.type === "plan" ? termItem.plan_id : termItem.rider_id;

                            if (id == null) return null;

                            return (
                                <td key={index} className={`px-2 py-1.5 ${index !== array.length - 1 ? 'border-r border-gray-100' : ''}`}>
                                    <input
                                        type="text"
                                        disabled={!isUpdateRates || isDisableInput}
                                        value={termItem.amount ?? ''}
                                        onChange={(e) => handleChangeAmount(id, e.target.value, dataRateAge.title, termItem.type)}
                                        onBlur={(e) => handleBlurAmount?.(id, e.currentTarget.value, dataRateAge.title, termItem.type)}
                                        className={`w-full min-w-[80px] rounded border px-2 py-1 text-right text-[11px] outline-none transition-colors ${defaultStyle} ${isUpdateRates === false ? 'border-transparent bg-transparent' : termItem.amount ? customStyle : 'border-gray-300 bg-white focus:border-[#186cb2] focus:ring-1 focus:ring-[#186cb2]/20'}`}
                                    />
                                </td>
                            );
                        })}
                    </tr>
                ))
            )}
        </tbody>
    );
}